import { render, staticRenderFns } from "./GiftCouponForm.vue?vue&type=template&id=51d20310&"
import script from "./GiftCouponForm.vue?vue&type=script&lang=js&"
export * from "./GiftCouponForm.vue?vue&type=script&lang=js&"
import style0 from "./GiftCouponForm.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports